
const digest = '5a4015d56347bbf0c52afd298be96a4a9b0c97e92c5b19d66868a4a995d4349e';
const css = `._commandMenuItem_14z45_1 {
  display: contents; /* Let the natural display of children (implicit in aha-menu-item) take over. */
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItem":"_commandMenuItem_14z45_1"};
export { css, digest };
  